import apiClient from "../apiClient";
import storageService from "../../utils/storageService";

const getHeaders = () => {
    const subdomain = storageService.getItem('Tenant_Name') || '';
    return {
        subdomain: subdomain
    };
};

export const commercialVisitorNotificationService = {
    /**
     * Manage Notification Users for Commercial
     * @param {Object} payload - { unitId, userIds, actionByUserId }
     */
    manageNotificationUsers: async (payload) => {
        return apiClient.post('/Visitor/ManageNotificationUsers', payload, {
            headers: getHeaders()
        });
    },

    /**
     * Get Notification Users for Commercial
     * @param {number|string} unitId 
     */
    getNotificationUsers: async (unitId) => {
        return apiClient.get('/Visitor/GetNotificationUsers', {
            params: { unitId },
            headers: getHeaders()
        });
    }
};

export default commercialVisitorNotificationService;
